export const CHECKBOX_SIZE_MAP = {
    s: 's',
    m: 's',
    l: 'm',
};
